module.exports = __webpack_public_path__ + "img/yw.4ad549c8.jpg";